/**
 * AUTO-GENERATED FILE - DO NOT EDIT MANUALLY
 * Generated by: scripts/generate-template-loaders.js
 * Source files:
 *   - repair.njk
 *   - repair.css
 */

export const REPAIR_TEMPLATE = `{% if isA4 %}
<div class="a4-container" style="padding: 40px; box-shadow: var(--inv-shadow); border: var(--inv-card-border); border-radius: var(--inv-radius); max-width: var(--inv-width); margin: 0 auto; background: #fff;">
  <!-- Header Row (50/50 Split) -->
  <div class="a4-hdr-row">
    <div class="a4-hdr-left">
      {% if logoUrl %}
        <img class="a4-hdr-logo-img" src="{{ logoUrl }}" alt="{{ storeName }}"/>
      {% endif %}
    </div>
    <div class="a4-hdr-right-store">
      <div class="store-title">{{ storeName }}</div>
      {% if address %}<p>{{ address | replace('\\n', ', ') }}</p>{% endif %}
      {% if phone %}<p>Tel: {{ phone }}</p>{% endif %}
    </div>
  </div>

  <!-- Horizontal Metadata Row -->
  <div class="a4-meta-row">
    <div class="a4-meta-col">
      <span class="a4-meta-lbl">Job No</span>
      <strong class="a4-meta-val">{{ jobNo }}</strong>
    </div>
    <div class="a4-meta-col">
      <span class="a4-meta-lbl">Date</span>
      <strong class="a4-meta-val">{{ dateStr }}</strong>
    </div>
    {% if promisedDate %}
    <div class="a4-meta-col">
      <span class="a4-meta-lbl">Promised Date</span>
      <strong class="a4-meta-val">{{ promisedDate }}</strong>
    </div>
    {% endif %}
    <div class="a4-meta-col text-right">
      <span class="a4-meta-lbl">Status</span>
      <span class="status-badge-a4 active" style="font-weight: bold;">RECEIVED</span>
    </div>
  </div>

  <!-- Customer & Device Grid Info -->
  <div style="display: flex; gap: 20px; margin-bottom: 20px;">
    <!-- Customer Info Card -->
    <div class="a4-cust-card" style="flex: 1; margin: 0; padding: 15px; border: 1px solid #dee2e6; border-radius: 8px; background: #f8f9fa;">
      <h4 style="margin-bottom: 10px; text-transform: uppercase; font-size: 0.85em; color: #666; border-bottom: 1px solid #dee2e6; padding-bottom: 4px;">Customer Info</h4>
      <div class="a4-cust-grid" style="grid-template-columns: 100px 1fr;">
        <span class="a4-cust-lbl">Name:</span>
        <span class="a4-cust-val">{{ customerName }}</span>
        
        {% if customerPhone %}
          <span class="a4-cust-lbl">Contact:</span>
          <span class="a4-cust-val">{{ customerPhone }}</span>
        {% endif %}
        
        {% if customerEmail %}
          <span class="a4-cust-lbl">Email:</span>
          <span class="a4-cust-val" style="text-transform: none;">{{ customerEmail }}</span>
        {% endif %}

        {% if customerAddress %}
          <span class="a4-cust-lbl">Address:</span>
          <span class="a4-cust-val">{{ customerAddress }}</span>
        {% endif %}
      </div>
    </div>

    <!-- Device Info Card -->
    <div class="a4-cust-card" style="flex: 1; margin: 0; padding: 15px; border: 1px solid #dee2e6; border-radius: 8px; background: #f8f9fa;">
      <h4 style="margin-bottom: 10px; text-transform: uppercase; font-size: 0.85em; color: #666; border-bottom: 1px solid #dee2e6; padding-bottom: 4px;">Device Info</h4>
      <div class="a4-cust-grid" style="grid-template-columns: 100px 1fr;">
        <span class="a4-cust-lbl">Device:</span>
        <span class="a4-cust-val">{{ deviceLabel }}</span>
        
        {% if imei %}
          <span class="a4-cust-lbl">IMEI:</span>
          <span class="a4-cust-val">{{ imei }}</span>
        {% endif %}
        
        {% if serialNumber %}
          <span class="a4-cust-lbl">Serial No:</span>
          <span class="a4-cust-val">{{ serialNumber }}</span>
        {% endif %}

        {% if devicePassword %}
          <span class="a4-cust-lbl">Password:</span>
          <span class="a4-cust-val" style="text-transform: none;">{{ devicePassword }}</span>
        {% endif %}
      </div>
    </div>
  </div>

  <!-- Job Diagnosis & Issues Section -->
  <div style="border: 1px solid #dee2e6; border-radius: 8px; padding: 15px; background: #fff; margin-bottom: 20px; font-size: 0.95em;">
    <div style="margin-bottom: 8px;">
      <strong style="color: #64748b; font-size: 0.85em; text-transform: uppercase; display: inline-block; width: 140px;">Reported Issues:</strong>
      <span style="color: #212529;">{{ reportedIssues }}</span>
    </div>
    {% if diagnosis %}
    <div style="margin-bottom: 8px;">
      <strong style="color: #64748b; font-size: 0.85em; text-transform: uppercase; display: inline-block; width: 140px;">Diagnosis:</strong>
      <span style="color: #212529;">{{ diagnosis }}</span>
    </div>
    {% endif %}
    {% if technicianNotes %}
    <div>
      <strong style="color: #64748b; font-size: 0.85em; text-transform: uppercase; display: inline-block; width: 140px;">Technician Notes:</strong>
      <span style="color: #212529;">{{ technicianNotes }}</span>
    </div>
    {% endif %}
  </div>

  <!-- Parts/Materials Used Table (If any) -->
  {% if items.length > 0 %}
  <div style="margin-bottom: 20px;">
    <h4 style="margin-bottom: 8px; font-size: 0.95em; font-weight: 700; text-transform: uppercase; border-bottom: 2px solid #dee2e6; padding-bottom: 4px;">Parts / Materials Used</h4>
    <table class="a4-items-table">
      <thead>
        <tr>
          <th class="a4-col-no">NO</th>
          <th class="a4-col-desc">PART DESCRIPTION</th>
          <th class="a4-col-price">UNIT RATE</th>
          <th class="a4-col-qty">QTY</th>
          <th class="a4-col-amount">TOTAL</th>
        </tr>
      </thead>
      <tbody>
        {% for item in items %}
        <tr class="a4-item-row">
          <td class="a4-col-no">{{ loop.index }}</td>
          <td class="a4-desc-cell">{{ item.part_name }}</td>
          <td class="a4-price-cell">{{ item.unit_price | formatPrice }}</td>
          <td class="a4-qty-cell">{{ item.quantity }}</td>
          <td class="a4-amount-cell">{{ item.total_price | formatPrice }}</td>
        </tr>
        {% endfor %}
      </tbody>
    </table>
  </div>
  {% endif %}

  <!-- Modern Summary Section -->
  <div class="a4-summary-container">
    <div class="a4-summary-left-card">
      <div class="a4-info-row">
        <span class="a4-info-label">Promised Delivery</span>
        <span class="a4-info-value">{{ promisedDate or "N/A" }}</span>
      </div>
      <div class="a4-info-row">
        <span class="a4-info-label">Device Password</span>
        <span class="a4-info-value" style="text-transform: none;">{{ devicePassword or "None" }}</span>
      </div>
      <div class="a4-info-row">
        <span class="a4-info-label">Ticket Status</span>
        <span class="a4-info-value status-badge-a4 active">RECEIVED</span>
      </div>
    </div>

    <div class="a4-summary-right-totals">
      <div class="a4-total-row">
        <span class="a4-total-lbl">Selling Price</span>
        <span class="a4-total-val">{{ currency }} {{ sellingPrice | formatPrice }}</span>
      </div>
      <div class="a4-grand-total-row">
        <span class="a4-grand-lbl">GRAND TOTAL</span>
        <span class="a4-grand-val">{{ currency }} {{ sellingPrice | formatPrice }}</span>
      </div>
      <div style="border-top: 1px dashed #dee2e6; margin-top: 5px; padding-top: 5px;"></div>
      <div class="a4-total-row" style="font-weight: 600;">
        <span class="a4-total-lbl">Total Paid (Advance)</span>
        <span class="a4-total-val">{{ currency }} {{ paidAmount | formatPrice }}</span>
      </div>
      {% if dueAmount > 0 %}
      <div class="a4-total-row" style="font-weight: 700; color: #d9534f;">
        <span class="a4-total-lbl">Balance Due</span>
        <span class="a4-total-val">{{ currency }} {{ dueAmount | formatPrice }}</span>
      </div>
      {% endif %}
    </div>
  </div>

  <!-- Payments Logged Table -->
  {% if payments.length > 0 %}
  <div class="a4-payments-section">
    <div class="a4-sec-title">Payments Logged</div>
    <table class="a4-payments-table">
      <thead>
        <tr>
          <th style="width: 25%;">Date & Time</th>
          <th style="width: 45%;">Method & Reference</th>
          <th style="width: 15%; text-align: right;">Amount</th>
          <th style="width: 15%;">Note</th>
        </tr>
      </thead>
      <tbody>
        {% for pay in payments %}
        <tr>
          <td style="font-size: 0.9em; white-space: nowrap;">{{ (pay.payment_date or pay.created_at) | dateTimeFormat }}</td>
          <td>
            <strong style="text-transform: uppercase;">{{ pay.payment_method_name or 'Payment' }}</strong>
            {% if pay.transaction_no %}
            <div style="font-size: 0.85em; color: #555; margin-top: 2px;">Tx Ref: {{ pay.transaction_no }}</div>
            {% endif %}
            {% if pay.bank_name %}
            <div style="font-size: 0.85em; color: #555;">Bank: {{ pay.bank_name }}</div>
            {% endif %}
          </td>
          <td style="text-align: right; font-weight: bold; font-family: monospace;">{{ currency }} {{ pay.amount | formatPrice }}</td>
          <td style="font-size: 0.9em; color: #666;">{{ pay.notes or pay.note or '-' }}</td>
        </tr>
        {% endfor %}
      </tbody>
    </table>
  </div>
  {% endif %}

  <!-- Signature Section -->
  <div class="a4-signature-section">
    <div class="a4-sig-block">
      <div class="a4-sig-line"></div>
      <div class="a4-sig-label">Customer Signature</div>
    </div>
    <div class="a4-sig-block">
      <div class="a4-sig-line"></div>
      <div class="a4-sig-label">Authorized Signature</div>
    </div>
  </div>

  <!-- Bottom Footer -->
  <div class="a4-ftr">
    <div class="a4-ftr-note">{{ footer }}</div>
    <div class="a4-ftr-thank">Thank you for business, Visit us again!</div>
    <div class="a4-ftr-powered">Powered by TaproDev POS</div>
  </div>
</div>
{% else %}
<div class="wrap" style="max-width: var(--inv-width); margin: 0 auto; background: #fff; padding: var(--inv-pad); box-shadow: var(--inv-shadow); border-radius: var(--inv-radius);">
  <div class="hdr">
    {% if logoUrl %}
      <div><img class="hdr-logo" src="{{ logoUrl }}" alt="{{ storeName }}" style="max-height: 50px; max-width: 100%; object-fit: contain; margin-bottom: 6px;"/></div>
    {% endif %}
    <div class="store-name" style="font-weight: 700; text-transform: uppercase; font-size: 1.15em; margin-bottom: 2px; text-align: center;">{{ storeName }}</div>
    {% if address %}<p style="text-align: center; font-size: 0.85em; color: #666; margin: 2px 0;">{{ address | replace('\\n', '<br/>') | safe }}</p>{% endif %}
    {% if phone %}<p style="text-align: center; font-size: 0.85em; color: #666; margin: 2px 0;">Tel: {{ phone }}</p>{% endif %}
  </div>

  <hr class="hdr-divider" style="border: 0; border-top: 1px dashed #bbb; margin: 10px 0;"/>

  <table class="meta-table" style="width: 100%; font-size: 0.9em; margin-bottom: 10px;">
    <tbody>
      <tr>
        <td class="meta-lbl" style="font-weight: 600; color: #555; width: 90px; padding: 2px 0;">Job No:</td>
        <td class="meta-val" style="font-weight: 700; color: #000; padding: 2px 0;">{{ jobNo }}</td>
      </tr>
      <tr>
        <td class="meta-lbl" style="font-weight: 600; color: #555; padding: 2px 0;">Date:</td>
        <td class="meta-val" style="padding: 2px 0;">{{ dateStr }}</td>
      </tr>
      <tr>
        <td class="meta-lbl" style="font-weight: 600; color: #555; padding: 2px 0;">Customer:</td>
        <td class="meta-val" style="padding: 2px 0;">{{ customerName }}</td>
      </tr>
      {% if customerPhone %}
      <tr>
        <td class="meta-lbl" style="font-weight: 600; color: #555; padding: 2px 0;">Contact:</td>
        <td class="meta-val" style="padding: 2px 0;">{{ customerPhone }}</td>
      </tr>
      {% endif %}
    </tbody>
  </table>

  <hr class="meta-divider" style="border: 0; border-top: 1px dashed #bbb; margin: 10px 0;"/>

  <div class="device-section" style="font-size: 0.9em; line-height: 1.4; margin-bottom: 10px;">
    <h4 style="border-bottom: 1px dashed #aaa; padding-bottom: 2px; margin-bottom: 6px; text-transform: uppercase; font-size: 0.85em; color: #555;">Device Information</h4>
    <div class="row" style="display: flex; justify-content: space-between; margin-bottom: 3px;">
      <span class="meta-lbl" style="color: #666;">Device:</span>
      <span>{{ deviceLabel }}</span>
    </div>
    {% if imei %}
    <div class="row" style="display: flex; justify-content: space-between; margin-bottom: 3px;">
      <span class="meta-lbl" style="color: #666;">IMEI:</span>
      <span>{{ imei }}</span>
    </div>
    {% endif %}
    {% if serialNumber %}
    <div class="row" style="display: flex; justify-content: space-between; margin-bottom: 3px;">
      <span class="meta-lbl" style="color: #666;">Serial No:</span>
      <span>{{ serialNumber }}</span>
    </div>
    {% endif %}
    {% if promisedDate %}
    <div class="row" style="display: flex; justify-content: space-between; margin-bottom: 3px;">
      <span class="meta-lbl" style="color: #666;">Promised:</span>
      <span>{{ promisedDate }}</span>
    </div>
    {% endif %}
    <div class="row" style="display: flex; justify-content: space-between; margin-bottom: 3px;">
      <span class="meta-lbl" style="color: #666;">Issues:</span>
      <span style="text-align: right; max-width: 60%;">{{ reportedIssues }}</span>
    </div>
    {% if diagnosis %}
    <div class="row" style="display: flex; justify-content: space-between; margin-bottom: 3px;">
      <span class="meta-lbl" style="color: #666;">Diagnosis:</span>
      <span style="text-align: right; max-width: 60%;">{{ diagnosis }}</span>
    </div>
    {% endif %}
    {% if technicianNotes %}
    <div class="row" style="display: flex; justify-content: space-between; margin-bottom: 3px;">
      <span class="meta-lbl" style="color: #666;">Notes:</span>
      <span style="text-align: right; max-width: 60%;">{{ technicianNotes }}</span>
    </div>
    {% endif %}
  </div>

  <hr class="meta-divider" style="border: 0; border-top: 1px dashed #bbb; margin: 10px 0;"/>

  {% if items.length > 0 %}
  <div class="parts-section" style="font-size: 0.9em; margin-bottom: 10px;">
    <h4 style="border-bottom: 1px dashed #aaa; padding-bottom: 2px; margin-bottom: 6px; text-transform: uppercase; font-size: 0.85em; color: #555;">Parts / Materials Used</h4>
    <table style="width: 100%; border-collapse: collapse; font-size: 0.95em;">
      <thead>
        <tr style="border-bottom: 1px solid #000;">
          <th align="left" style="padding: 4px 0;">Part Name</th>
          <th align="center" style="width: 15%; padding: 4px 0;">Qty</th>
          <th align="right" style="width: 25%; padding: 4px 0;">Total</th>
        </tr>
      </thead>
      <tbody>
        {% for item in items %}
        <tr style="border-bottom: 1px dashed #ddd;">
          <td style="padding: 6px 0;">{{ item.part_name }}</td>
          <td align="center" style="padding: 6px 0;">{{ item.quantity }}</td>
          <td align="right" style="padding: 6px 0;"><b>{{ item.total_price | formatPrice }}</b></td>
        </tr>
        {% endfor %}
      </tbody>
    </table>
  </div>
  <hr class="meta-divider" style="border: 0; border-top: 1px dashed #bbb; margin: 10px 0;"/>
  {% endif %}

  <div class="payment-section" style="font-size: 0.9em; line-height: 1.4;">
    <h4 style="border-bottom: 1px dashed #aaa; padding-bottom: 2px; margin-bottom: 6px; text-transform: uppercase; font-size: 0.85em; color: #555;">Payment Summary</h4>
    <div class="row" style="display: flex; justify-content: space-between; margin-bottom: 3px;">
      <span>Selling Price</span>
      <span>{{ currency }} {{ sellingPrice | formatPrice }}</span>
    </div>
    <div class="row" style="display: flex; justify-content: space-between; margin-bottom: 3px;">
      <span>Paid Amount</span>
      <span style="color:#15803d; font-weight: 600;">{{ currency }} {{ paidAmount | formatPrice }}</span>
    </div>
    <div class="row" style="display: flex; justify-content: space-between; margin-bottom: 3px;">
      <span>Due Amount</span>
      <span style="color:{{ '#b91c1c' if dueAmount > 0 else '#15803d' }}; font-weight: 700;">{{ currency }} {{ dueAmount | formatPrice }}</span>
    </div>
    
    {% if payments.length > 0 %}
    <hr class="dashes" style="border: 0; border-top: 1px dashed #aaa; margin: 6px 0;"/>
    <h4 style="text-transform: uppercase; font-size: 0.8em; color: #555; margin-bottom: 4px;">Payments Logged</h4>
    {% for pay in payments %}
      <div class="row" style="font-weight: 600; padding-bottom: 0; margin-bottom: 0; display: flex; justify-content: space-between;">
        <span>{{ pay.payment_method_name or 'Payment' }}</span>
        <span>{{ currency }} {{ pay.amount | formatPrice }}</span>
      </div>
      <div style="font-size: 0.8em; color: #777; padding: 0 4px 2px 4px; text-align: left; line-height: 1.2;">
        <div>{{ (pay.payment_date or pay.created_at) | dateTimeFormat }}</div>
        {% if pay.transaction_no %}<div>Tx Ref: {{ pay.transaction_no }}</div>{% endif %}
        {% if pay.bank_name %}<div>Bank: {{ pay.bank_name }}</div>{% endif %}
      </div>
    {% endfor %}
    {% endif %}
  </div>

  <hr class="meta-divider" style="border: 0; border-top: 1px dashed #bbb; margin: 10px 0;"/>

  <!-- Signature section for 80mm -->
  <div class="sig-section" style="margin-top: 15px; font-size: 0.85em;">
    <div style="margin-bottom: 15px; text-align: center;">
      <div style="border-top: 1px dashed #888; width: 80%; margin: 10px auto 2px auto;"></div>
      <div>Customer Signature</div>
    </div>
    <div style="text-align: center;">
      <div style="border-top: 1px dashed #888; width: 80%; margin: 10px auto 2px auto;"></div>
      <div>Authorized Signature</div>
    </div>
  </div>

  <hr class="meta-divider" style="border: 0; border-top: 1px dashed #bbb; margin: 10px 0;"/>

  <div class="ftr" style="text-align: center; font-size: 0.85em; color: #555;">
    <p>{{ footer }}</p>
    <p style="margin-top:6px;font-size:0.8em;color:#999;">Powered by TaproDev POS</p>
  </div>
</div>
{% endif %}
`;

export const REPAIR_CSS = `/* ── 80mm Roll Container ── */
.wrap {
  width: var(--inv-width);
  margin: var(--inv-body-pad);
  background: #fff;
  padding: var(--inv-pad);
  box-shadow: var(--inv-shadow);
  border-radius: var(--inv-radius);
  box-sizing: border-box;
  font-family: 'Courier New', Courier, monospace;
  font-size: var(--inv-font);
  line-height: 1.4;
  color: #000;
}

.hdr {
  text-align: center;
  margin-bottom: 12px;
}

.hdr h2 {
  margin: 0 0 4px 0;
  font-size: var(--inv-h2-size);
  font-weight: 800;
  text-transform: uppercase;
}

.hdr p {
  margin: 2px 0;
  font-size: var(--inv-p-size);
  color: #444;
}

.meta-table {
  width: 100%;
  border-collapse: collapse;
}

.meta-lbl {
  color: #666;
  font-weight: bold;
}

.row {
  display: flex;
  justify-content: space-between;
  margin: 4px 0;
}

.ftr {
  text-align: center;
  margin-top: var(--inv-ftr-mt);
  font-size: var(--inv-ftr-size);
  color: #555;
}

.ftr p {
  margin: 2px 0;
}

/* ── A4 Layout Styling (100% same as classic) ── */
.a4-container {
  display: flex;
  flex-direction: column;
  font-family: Arial, Helvetica, sans-serif;
  color: #000;
  background: #fff;
  width: 100%;
}

.a4-hdr-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.a4-hdr-left {
  width: 50%;
  flex: 0 0 50%;
}

.a4-hdr-logo-img {
  max-height: 80px;
  max-width: 100%;
  object-fit: contain;
}

.a4-hdr-right-store {
  width: 50%;
  flex: 0 0 50%;
  text-align: right;
}

.a4-hdr-right-store .store-title {
  font-size: 1.5em;
  font-weight: 700;
  text-transform: uppercase;
  margin-bottom: 4px;
}

.a4-hdr-right-store p {
  font-size: 0.9em;
  margin: 2px 0;
  color: #333;
}

.a4-meta-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1.5px solid #000;
  border-bottom: 1.5px solid #000;
  padding: 8px 10px;
  margin-bottom: 20px;
  background-color: #f8f9fa;
  font-size: 0.9em;
}

.a4-meta-col {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.a4-meta-col.text-right {
  align-items: flex-end;
}

.a4-meta-lbl {
  font-size: 0.78em;
  text-transform: uppercase;
  color: #555;
  letter-spacing: 0.5px;
}

.a4-meta-val {
  font-size: 0.95em;
  color: #000;
}

.a4-cust-card {
  margin: 10px 0 20px 0;
  font-size: 0.95em;
}

.a4-cust-grid {
  display: grid;
  grid-template-columns: 140px 1fr;
  gap: 4px 10px;
}

.a4-cust-lbl {
  font-weight: 500;
  color: #333;
}

.a4-cust-val {
  font-weight: 700;
  text-transform: uppercase;
}

.a4-items-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
  font-size: 0.95em;
}

.a4-items-table th,
.a4-items-table td {
  border: 1px solid #888;
  padding: 8px 10px;
}

.a4-items-table th {
  background-color: #f2f2f2;
  font-weight: 700;
  text-transform: uppercase;
}

.a4-col-no { width: 6%; text-align: center; }
.a4-col-desc { width: 54%; text-align: left; }
.a4-col-price { width: 14%; text-align: right; }
.a4-col-qty { width: 10%; text-align: center; }
.a4-col-amount { width: 16%; text-align: right; }

.a4-item-row td {
  vertical-align: middle;
}

.a4-item-row .a4-desc-cell {
  text-align: left;
}

.a4-item-row .a4-price-cell {
  text-align: right;
}

.a4-item-row .a4-qty-cell {
  text-align: center;
}

.a4-item-row .a4-amount-cell {
  text-align: right;
  font-weight: 500;
}

/* Summary Section */
.a4-summary-container {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: 20px;
  gap: 30px;
}

.a4-summary-left-card {
  width: 45%;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #dee2e6;
  padding: 15px;
}

.a4-info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e9ecef;
  padding-bottom: 8px;
  margin-bottom: 8px;
}

.a4-info-row:last-child {
  border-bottom: none;
  padding-bottom: 0;
  margin-bottom: 0;
}

.a4-info-label {
  color: #495057;
  font-weight: 500;
  font-size: 0.9em;
}

.a4-info-value {
  font-weight: 700;
  color: #212529;
  font-size: 0.9em;
}

.payment-badge {
  text-transform: uppercase;
  background-color: #e9ecef;
  padding: 2px 8px;
  border-radius: 4px;
}

.status-badge-a4 {
  padding: 3px 10px;
  border-radius: 12px;
  font-weight: 700;
  font-size: 0.85em;
  text-transform: uppercase;
}

.status-badge-a4.active {
  background-color: #d4edda;
  color: #155724;
}

.a4-summary-right-totals {
  width: 45%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  text-align: right;
}

.a4-total-row {
  display: flex;
  justify-content: space-between;
  font-size: 0.95em;
  color: #495057;
}

.a4-grand-total-row {
  display: flex;
  justify-content: space-between;
  border-top: 2px solid #212529;
  padding-top: 10px;
  margin-top: 5px;
}

.a4-grand-lbl {
  font-weight: 700;
  font-size: 1.15em;
  color: #212529;
}

.a4-grand-val {
  font-weight: 700;
  font-size: 1.15em;
  color: #212529;
}

/* Payments Logged Section */
.a4-payments-section {
  margin-top: 25px;
}

.a4-sec-title {
  font-size: 1.05em;
  font-weight: 700;
  text-transform: uppercase;
  margin-bottom: 12px;
  border-bottom: 2px solid #dee2e6;
  padding-bottom: 6px;
  color: #212529;
}

.a4-payments-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
  margin-bottom: 20px;
}

.a4-payments-table th {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  padding: 8px 12px;
  font-weight: 700;
  text-transform: uppercase;
  font-size: 0.85em;
  color: #495057;
  text-align: left;
}

.a4-payments-table td {
  border: 1px solid #dee2e6;
  padding: 10px 12px;
  vertical-align: top;
  font-size: 0.9em;
  color: #212529;
}

.a4-payments-table tr:nth-child(even) td {
  background-color: #fcfcfc;
}

/* Signature & Footer blocks */
.a4-signature-section {
  display: flex;
  justify-content: space-between;
  margin-top: 60px;
  margin-bottom: 20px;
  padding: 0 15px;
}

.a4-sig-block {
  width: 220px;
  text-align: center;
}

.a4-sig-line {
  border-top: 1px solid #333;
  margin-bottom: 6px;
}

.a4-sig-label {
  font-size: 0.85em;
  font-weight: 600;
  color: #495057;
}

.a4-ftr {
  text-align: center;
  margin-top: 40px;
  font-size: 0.9em;
  line-height: 1.5;
}

.a4-ftr-note {
  font-style: italic;
  margin-bottom: 6px;
}

.a4-ftr-thank {
  font-weight: 700;
  font-size: 1.05em;
}

.a4-ftr-powered {
  margin-top: 8px;
  font-size: 0.8em;
  color: #777;
}

@media print {
  body {
    background: #fff;
    padding: 0;
  }
  .a4-container {
    box-shadow: none;
    border: none;
    border-radius: 0;
    width: 100% !important;
    padding: 0 !important;
  }
  .wrap {
    box-shadow: none;
    border-radius: 0;
    width: 100% !important;
    padding: 0 !important;
    margin: 0 !important;
  }
  @page {
    size: var(--inv-page-size, A4);
    margin: 10mm;
  }
}
`;
